import { configureStore } from "@reduxjs/toolkit";
import authSlice from "context/features/authSlice";
import dataSlice from "context/features/dataSlice";
import stylesSlice from "context/features/stylesSlice";
import {
  profileReducer,
  accountReducer,
  subscriptionsReducer,
} from "features/User/context";
import searchSlice from "features/SourceSearch/context/searchSlice";
import { groupReducer } from "features/Group";
import { adminReducer } from "features/Admin";
import { geoDataReducer } from "features/GeoData";
import { publisherReducer } from "features/PublisherAnalytics/context";
import { comparisonReducer } from "features/PublisherAnalytics/context/comparisonSlice";
import { settingsReducer } from "features/Settings/context/settingsSlice";

export default configureStore({
  reducer: {
    account: accountReducer,
    admin: adminReducer,
    auth: authSlice,
    comparison: comparisonReducer,
    data: dataSlice,
    geo: geoDataReducer,
    group: groupReducer,
    profile: profileReducer,
    publisher: publisherReducer,
    search: searchSlice,
    settings: settingsReducer,
    styles: stylesSlice,
    subs: subscriptionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: Number(process.env.REACT_APP_DEV_TOOLS),
});
